import { toast } from "sonner";

export const copyShareUrl = async (shareUrl: string) => {
  if (!shareUrl) return;
  try {
    await navigator.clipboard.writeText(shareUrl);
    toast.success("Link copied to clipboard!");
  } catch (error) {
    console.error(error);
    toast.error("Could not copy the link");
  }
};
